class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        const target = document.getElementById(section.id);
        if (!target) return;
        target.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      // P0 fix: refresh drawer markup zodat #cart_reload geen stale empty-state
      // toont na add-to-cart van buiten de drawer. Cart-drawer section wordt
      // server-side opgenomen in /cart/add.js sections-response.
      if (parsedState.sections && parsedState.sections['cart-drawer'] && window.OliereusCart) {
        window.OliereusCart.applySections({ 'cart-drawer': parsedState.sections['cart-drawer'] });
      }

      this.header?.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      },
      {
        // cart-drawer staat in deze lijst zodat product-form.js het meeneemt in
        // de sections-querystring naar /cart/add.js. De generieke render-loop
        // hierboven doet niets voor dit item (er is geen DOM-element met id
        // "cart-drawer"), de daadwerkelijke #cart_reload injection gebeurt via
        // OliereusCart.applySections in renderContents (P0 stale-state fix).
        id: 'cart-drawer',
        selector: '#cart_reload'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
